import React from 'react';

import logo from '../gm_logo.png';

const Footer = ({ termsUrl }) => (
  <footer className="container">
    <div className="row">
      <div className="col-md-12">
        {<h1 className="logo"><img src={logo} width="100px"/></h1>}
        <a href={ termsUrl && termsUrl !== "" ? termsUrl : "https://www.gomoment.com/terms/" }>Terms</a> -
        <a href="https://www.gomoment.com/privacy/"> Privacy</a>
      </div>
    </div>
  </footer>
)

export default Footer;
